import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.25 6.766c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.371c0-.517-.351-.967-.852-1.092l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293a1.06 1.06 0 0 1-1.21.38 12.04 12.04 0 0 1-7.143-7.143c-.162-.44.004-.928.38-1.21l1.293-.97c.363-.271.527-.733.417-1.173L6.963 3.118a1.125 1.125 0 0 0-1.091-.852H4.5a2.25 2.25 0 0 0-2.25 2.25z"
    }, null, -1)
  ])))
}
export default { render: render }